import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IHospitalLicense } from 'app/models/licenses/hospital/hospital-license';
import { IRepresentativeContact } from 'app/models/licenses/hospital/representative-contact';
import { ILicenseRequest } from 'app/models/licenses/license-request';

@Injectable({providedIn: 'root'})
export class HospitalLicenseService {
  private api: string = environment.privateApi + 'HospitalLicense/';

  private http = inject(HttpClient);

  public getLicenses(): Observable<IHospitalLicense[]> {
    return this.http.get<IHospitalLicense[]>(this.api + 'GetLicenses');
  }

  public updateLicense(license: IHospitalLicense): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'UpdateLicense', license);
  }

  public submitLicense(license: IHospitalLicense): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'SubmitLicense', license);
  }

  public renewLicense(licenseId: string): Observable<IHospitalLicense>{
    return this.http.post<IHospitalLicense>(this.api + 'RenewLicense/' + licenseId, null);
  }

  public getLicenseRequests(): Observable<ILicenseRequest[]>{
    return this.http.get<ILicenseRequest[]>(this.api + 'GetLicenseRequests');
  }

  public cancelLicenseRequest(licenseRequestId: number): Observable<boolean>{
    return this.http.delete<boolean>(this.api + 'CancelLicenseRequest/' + licenseRequestId);
  }

  public requestLicense(licenseRequest: ILicenseRequest): Observable<number>{
    return this.http.post<number>(this.api + 'RequestLicense', licenseRequest);
  }

  public checkIfLicenseExists(licenseNumber: string): Observable<boolean> {
    return this.http.get<boolean>(this.api + 'CheckIfLicenseExists/' + licenseNumber);
  }

  // Representative Contacts
  public addRepresentativeContact(contact: IRepresentativeContact): Observable<IRepresentativeContact> {
    return this.http.post<IRepresentativeContact>(this.api + 'AddRepresentativeContact', contact);
  }

  public updateRepresentativeContact(contact: IRepresentativeContact): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'UpdateRepresentativeContact', contact);
  }

  public deleteRepresentativeContact(contactId: number): Observable<boolean> {
    return this.http.delete<boolean>(this.api + 'DeleteRepresentativeContact/' + contactId);
  }

  public checkDuplicateChiefNurseName(chiefNurseName: string, licenseId: string): Observable<boolean> {
    return this.http.get<boolean>(this.api + 'CheckDuplicateChiefNurseName/' + chiefNurseName + '/' + licenseId);
  }

  public checkDuplicateDirectCareCoChair(directCoChairName: string, licenseId: string): Observable<boolean> {
    return this.http.get<boolean>(this.api + 'CheckDuplicateDirectCareCoChair/' + directCoChairName + '/' + licenseId);
  }

  public checkDuplicateStaffingCommitteeStaffCoChair(serviceStaffingCommitteeStaffCoChairName: string, licenseId: string): Observable<boolean> {
    return this.http.get<boolean>(this.api + 'CheckDuplicateStaffingCommitteeStaffCoChair/' + serviceStaffingCommitteeStaffCoChairName + '/' + licenseId);
  }
}
